import React from "react";
import styled, { css } from "styled-components";
import { TypographyVariant } from "types/theme";

interface TypographyProps {
  disabled?: boolean;
  children: React.ReactNode;
  variant?: TypographyVariant;
  color?: string;
  onClick?: () => void;
}

export const Typography: React.FC<TypographyProps> = props => {
  const { children, variant = "body1", disabled, ...other } = props;

  switch (variant) {
    default:
      return (
        <BasicContainer variant={variant} disabled={disabled} {...other}>
          {children}
        </BasicContainer>
      );
  }
}

const styles = css<TypographyProps & { variant: TypographyVariant; }>`
  color: ${(props) => props.color || props.theme.palette.text.primary};
  ${(props) => {
  const { desktop, mobile } = props.theme.typography;
  return `
      font-size: ${mobile[props.variant].fontSize};
      line-height: ${mobile[props.variant].lineHeight};
      font-weight: ${mobile[props.variant].fontWeight};
      @media screen and (max-width: ${props.theme.breakpoints.TabletMax}) {) {
        font-size: ${desktop[props.variant].fontSize};
        line-height: ${desktop[props.variant].lineHeight};
        font-weight: ${desktop[props.variant].fontWeight};
      }
    `;
}}
`;

const BasicContainer = styled.span<TypographyProps>`
  ${styles as unknown as any}
`;
